//Change object's null or undefined value to ""
const handleNull = (data) => {
  //Array is also a object
  let newData;
  if (typeof data == 'object') {
    if (Array.isArray(data)) {
      newData = [...data];
    } else {
      newData = { ...data };
    }
  }
  Object.keys(newData).map((key) => {
    if (newData[key] === null || newData[key] === undefined) {
      newData[key] = '';
    } else if (typeof newData[key] == 'object') {
      newData[key] = handleNull(newData[key]);
    }
  });
  return newData;
};

export default handleNull;
